import StaticContentPage from './StaticContentPage';

export default function TermsPage() {
  return <StaticContentPage slug="terms" fallbackTitle="Terms and Conditions" />;
}

